var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, createContext, useContext } from "react";
import { Button } from "reakit/Button";
import styled from "styled-components";
import { useContent } from "../Content/Content";
import { styleValues, colors } from "../shared/constants";
var StyledCard = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: ", ";\n  background-color: ", ";\n  border-width: 2px;\n  border-style: solid;\n  border-color: ", ";\n  border-radius: 16px;\n  padding: 16px;\n  margin-top: 8px;\n  margin-left: 8px;\n  margin-right: 8px;\n  margin-bottom: 32px;\n  cursor: pointer;\n"], ["\n  box-shadow: ", ";\n  background-color: ",
    ";\n  border-width: 2px;\n  border-style: solid;\n  border-color: ",
    ";\n  border-radius: 16px;\n  padding: 16px;\n  margin-top: 8px;\n  margin-left: 8px;\n  margin-right: 8px;\n  margin-bottom: 32px;\n  cursor: pointer;\n"])), styleValues.bowShadow, function (props) { var _a, _b, _c; return props.selected ? (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.light : colors.WHITE; }, function (props) { var _a, _b, _c; return props.selected ? (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.dark : "transparent"; });
var RadioContext = createContext({
    name: "",
    value: "",
    setValue: function () { }
});
export var RadioCards = function (_a) {
    var name = _a.name, value = _a.value, setFieldValue = _a.setFieldValue, children = _a.children;
    return (React.createElement(RadioContext.Provider, { value: {
            name: name,
            value: value,
            setValue: function (value) { return setFieldValue(name, value); }
        } }, children));
};
export var RadioCard = function (_a) {
    var value = _a.value, children = _a.children, rest = __rest(_a, ["value", "children"]);
    var _b = useContext(RadioContext), selectedValue = _b.value, setValue = _b.setValue;
    var handleClick = useCallback(function (e) {
        e.preventDefault();
        setValue(value);
    }, [value]);
    var theme = useContent().theme;
    var selected = value === selectedValue;
    return (React.createElement(StyledCard, __assign({ selected: selected, theme: theme }, rest, { role: "radio", onClick: handleClick }), children({ selected: selected })));
};
var templateObject_1;
